
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEqual as ObiEqualElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-equal.js';
 
 
 

 
 export const ObiEqual = createComponent({
   react: React,
   tagName: 'obi-equal',
   elementClass: ObiEqualElement,
   events: {
     
   }
  });
 
 